<template>
  <StackPageLayout @close="handleClose">
    <template #title> New Category </template>

    <div
      class="flex min-h-full flex-col rounded-lg bg-background p-3"
    >
      <CategoryForm @submit="handleSubmit" />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import type { CategoryFormOutput } from "@/forms/categoryForm"
import { createCategory } from "@/services/categories/createCategory"

const { startLoading, stopLoading } =
  usePageBlockingLoading()

const router = useRouter()

const handleClose = () =>
  router.push({ name: "settingsCategoryIndex" })

const handleSubmit = async (params: CategoryFormOutput) => {
  startLoading()
  try {
    await createCategory(params)
    toast.success("Category created")
    router.push({ name: "settingsCategoryIndex" })
  } catch {
    toast.error("Failed to create category")
  } finally {
    stopLoading()
  }
}
</script>
